import { BrokerCarrier } from '@api/Trinium/Endpoints/Broker/types';

import styles from './DataGrid.Broker.module.css';

interface MobileBrokerItemProps {
	broker: BrokerCarrier;
}

export default function BrokerMobileItem({ broker }: MobileBrokerItemProps) {
	return (
		<div className={styles['mobile-li']}>
			<div className={styles.topleft}>
				<span>{broker.name}</span>
			</div>

			<span className={styles.bottomleft}>{broker.id}</span>
			<span className={styles.bottomcenter}></span>

			<div className={styles.topright}>
				<span className={styles.label}>Liability</span>
				<div className={styles.detail}>
					<span>{`$ ${broker.liabInsAmt?.toLocaleString() ?? '0.00'}`}</span>
					<span>{broker.liabInsExpirationDate?.shortDateExtended ?? 'N/A'}</span>
				</div>
			</div>

			<div className={styles.bottomright}>
				<span className={styles.label}>Cargo</span>
				<div className={styles.detail}>
					<span>{`$ ${broker.cargoInsAmt?.toLocaleString() ?? '0.00'}`}</span>
					<span>{broker.cargoInsExpriationDate?.shortDateExtended ?? 'N/A'}</span>
				</div>
			</div>
		</div>
	);
}
